import React, { Fragment, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3CustomInput from '@Uilib/h3CustomInput';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import './style.scss';

const GRNLineCustomField = ({
  customFields, formSubmitted, customInputChange, cfWrapperClassName, disableCase,
  isHorizontalUi, inputClassName, match, isCarryForward, isUpdate,
  labelClassName, containerClassName, hideTitle, wrapperClassName, customClassName,
}) => {
  const isDocumentInUpdateState = match.url.includes('/update') || (isUpdate === true);
  const isDocumentIsCarryForwarding = isCarryForward;
  // Helper function to determine if the input should be disabled
  const shouldDisableField = (customField) => (
    disableCase
    || (isDocumentInUpdateState && customField.isEditable === false)
    || (isDocumentIsCarryForwarding && customField.isCarryForward === false)
  );
  return (
    <div
      style={{
        width: '270px',
      }}
      className="create-grn__cf-wrapper"
    >
      {customFields?.filter((item) => (item.visible && item.isActive && item?.fieldType?.toUpperCase() !== 'ATTACHMENT' && item?.fieldType?.toUpperCase() !== 'CHECKBOX' && item?.fieldType?.toUpperCase() !== 'TEXTAREA'))?.map((customField, index) => (
        <React.Fragment key={customField?.cfId}>
          <div key={customField?.cfId} className={wrapperClassName}>
            <H3CustomInput
              containerClassName="create-grn-cf__input-wrapper"
              customClassName="pr_input_custom_field"
              labelClassName="create-grn-cf__input-label"
              inputClassName={`orgFormInput  custom-field-input ${(formSubmitted && customField?.isRequired && (Number(customField?.fieldValue) <= 0 || customField?.fieldValue === '')) ? 'orgFormInputError' : ''}`}
              inputErrorClassName="cf__input-error"
              type={customField?.fieldType?.toUpperCase()}
              required={customField?.isRequired}
              label={customField?.fieldName}
              options={customField?.defaultData?.length ? customField?.defaultData : []}
              placeholder={customField?.placeholder}
              onChange={(value) => customInputChange(value, customField?.cfId)}
              value={customField?.fieldValue}
              // showError={formSubmitted && customField?.isRequired && !customField?.fieldValue}
              disabled={shouldDisableField(customField)}
              showErrorCheckBox={(formSubmitted && customField?.isRequired && (Number(customField?.fieldValue) <= 0 || customField?.fieldValue === ''))}
            />
          </div>
        </React.Fragment>
      ))}

      {customFields?.filter((item) => (item.visible && item.isActive && item?.fieldType?.toUpperCase() === 'ATTACHMENT' || item?.fieldType?.toUpperCase() === 'CHECKBOX' || item?.fieldType?.toUpperCase() === 'TEXTAREA'))?.map((customField, index) => (
        <React.Fragment key={customField?.cfId}>
          <div key={customField?.cfId} className={wrapperClassName}>
            <H3CustomInput
              containerClassName="create-grn-cf__input-wrapper"
              customClassName="pr_input_custom_field"
              labelClassName="create-grn-cf__input-label"
              inputClassName={`orgFormInput  custom-field-input ${(formSubmitted && customField?.isRequired && (Number(customField?.fieldValue) <= 0 || customField?.fieldValue === '')) ? 'orgFormInputError' : ''}`}
              inputErrorClassName="cf__input-error"
              type={customField?.fieldType?.toUpperCase()}
              required={customField?.isRequired}
              label={customField?.fieldName}
              options={customField?.defaultData?.length ? customField?.defaultData : []}
              placeholder={customField?.placeholder}
              onChange={(value) => customInputChange(value, customField?.cfId)}
              value={customField?.fieldValue}
              // showError={formSubmitted && customField?.isRequired && !customField?.fieldValue}
              disabled={shouldDisableField(customField)}
              showErrorCheckBox={(formSubmitted && customField?.isRequired && (Number(customField?.fieldValue) <= 0 || customField?.fieldValue === ''))}
              islineFields
              isForGRNLine
            />
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
const mapStateToProps = () => ({

});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GRNLineCustomField));
